export const IDENTIFICATION_TYPE = 'OfficialIdentification';
export const IDENTIFICATION_BACK_TYPE = 'OfficialIdentificationBack';
export const HOME_TYPE = 'ProofOfAddress';
export const OTHER_TYPE = 'ProofOfIncome';
export const DRIVER_LICENSE_TYPE = 'DriverLicense';
export const PROOF_OF_TAX_STATUS_TYPE = 'ProofOfTaxStatus';
export const ADDITIONAL_DOCUMENT_TYPE = 'AdditionalDocument';

export const IFE_FRONT_SECTION = 'IFE-FRONT';
export const IFE_BACK_SECTION = 'IFE-BACK';
export const HOME_SECTION = 'HOME';
export const WORK_SECTION = 'WORK';
export const INCOMES_FIRST_SECTION = 'INCOMES_FIRST_SECTION';
export const INCOMES_SECOND_SECTION = 'INCOMES_SECOND_SECTION';
export const INCOMES_THIRD_SECTION = 'INCOMES_THIRD_SECTION';
export const DRIVER_LICENSE_FRONT_SECTION = 'DRIVER_LICENSE_FRONT';
export const DRIVER_LICENSE_BACK_SECTION = 'DRIVER_LICENSE_BACK';

export const ordinalWordsUppercase = [
    { english: '', spanish: '' },
    { english: 'first', spanish: 'primero' },
    { english: 'second', spanish: 'segundo' },
    { english: 'third', spanish: 'tercero' },
    { english: 'fourth', spanish: 'cuarto' },
    { english: 'fifth', spanish: 'quinto' },
    { english: 'sixth', spanish: 'sexto' },
    { english: 'seventh', spanish: 'séptimo' },
    { english: 'eighth', spanish: 'octavo' },
    { english: 'ninth', spanish: 'noveno' },
    { english: 'tenth', spanish: 'décimo' },
    { english: 'eleventh', spanish: 'undécimo' },
    { english: 'twelfth', spanish: 'duodécimo' },
    { english: 'thirteenth', spanish: 'decimotercero' },
    { english: 'fourteenth', spanish: 'decimocuarto' },
    { english: 'fifteenth', spanish: 'decimoquinto' },
    { english: 'sixteenth', spanish: 'decimosexto' },
    { english: 'seventeenth', spanish: 'decimoséptimo' },
    { english: 'eighteenth', spanish: 'decimoctavo' },
    { english: 'nineteenth', spanish: 'decimonoveno' },
    { english: 'twentieth', spanish: 'vigésimo' }
];
export const INCOMES_NTH_SECTION = (num) => `INCOMES_${ordinalWordsUppercase[num].english.toUpperCase()}_SECTION`;
